module.exports = __webpack_public_path__ + "img/1578678886.1f9e3a40.jpg";